import React from 'react';
import * as reactUtils from '../packages/react-utils/react-utils.js';
import '@flixbus/honeycomb-icons-react';
import '../packages/props-utils/prop-types.js';

/**
 * Validates label props based on acceptable Label text prop.
 */
const inputLabelValidator = function () {
  let componentName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Input';
  return _ref => {
    let {
      'aria-label': ariaLabel,
      label
    } = _ref;
    if (!ariaLabel && !label) {
      return new Error("".concat(componentName, " component requires either a label or aria-label."));
    }
    if (label && typeof label !== 'string' && ! /*#__PURE__*/React.isValidElement(label)) {
      return new Error("".concat(componentName, " component only accepts a \"Label\" component or a valid ReactElement as label, but received ").concat(reactUtils.getElementName(label), "."));
    }
    return null;
  };
};

export { inputLabelValidator };
